import { gql } from '@apollo/client';

export const IBC_INSTRUCTION = gql`
  fragment IbcInstruction on IdentifierBasedInstruction {
    id
    identifier
    treatmentId
    treatment {
      id
      name
      description
      reconOrder
    }
    notes
    publicName
    publicNotes
    updatedAt
    tokenParam1
    tokenParam2
  }
`;
